'use client';

import { ThemeProviderContext } from '@mxa-argos/components/refine/theme/theme-context';
import { useContext } from 'react';

export function useTheme() {
  const context = useContext(ThemeProviderContext);

  if (context === undefined) {
    console.error('useTheme must be used within a ThemeProvider');
  }

  return context;
}
